<template>
  <div>
    <div>
      <b-row>
        <b-col>
          <b-button-group>
            <b-button 
              v-for="m in modes" 
              :key="m" 
              :disabled="mode === m"
              @click="mode = m"
            >
              {{ m }}
            </b-button>
          </b-button-group>
        </b-col>
      </b-row>
      <b-row v-if="mode == 'documenten'">
        <b-col>
          <div class="pull-right">
            <b-input-group class="my-2 border-2 pull-right">
              <b-input-group-prepend is-text>
                Map
              </b-input-group-prepend>
              <b-button-group>
                <b-button 
                  :disabled="filter === null" 
                  @click="filter = null"
                >
                  Alle mappen
                </b-button>
                <b-button
                  v-for="f in contracten.filters" 
                  :key="f" 
                  :disabled="filter === f"
                  @click="filter = f"
                >
                  {{ f }}
                </b-button>
              </b-button-group>
            </b-input-group>
          </div>
          <h1>Contractdocumenten</h1>
          <b-table 
            :items="contracten.documenten"
            :caption="contracten.path"
            :filter="filter"
            :fields="[{
              key:'datum',
              label: 'Geupload op'
            },{key: 'grootte', label: 'Bestandsgrootte'},{
              key:'bestandsnaam',
              label: 'Bestand'
            },'map']"
            
            selectable
            bordered
            hover
            select-mode="single"
            striped
            dark
            small
          />
          
          <b-form-group>
            <b-input-group>
              <b-input-group-prepend is-text>
                Upload document
              </b-input-group-prepend>
              <b-file
                v-model="upload_document"
                accept=".pdf"
                placeholder="Kies contract in .pdf of sleep hierheen"
                drop-placeholder="Laat maar los..."
                browse-text="Kies bestand"
              />
          
              <!--- button upload contract-->
              <b-button 
                v-if="upload_document"
                style="z-index: 100" 
                @click="upload()"
              >
                <b-spinner 
                  v-if="busy" 
                  :small="true" 
                  size="sm" 
                  role="status"
                />
                <i class="fa fa-upload" />

                {{ busy ? 'Uploading...' : 'Uploaden' }}
              </b-button>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col class="p-4 border">
          PDF DOCUMENT VIEWER
        </b-col>
      </b-row>
      <b-row v-else>
        <b-col>
          <RelatieContractAfspraken />
        </b-col>
      </b-row>
    </div>
    <!-- 
        <div>
            <h2 v-if="isInstallateurSelected">Contractafspraken {{ installateur }} voor {{ jaar }}</h2>
            <h2 v-else>Standaard contractafspraken voor {{ jaar }}</h2>
            [selectie jaar + afspraken invoer]
        </div> 
    -->
  </div>
</template>
<script>
import { serviceMixin } from "@/mixins/serviceMixin";
import RelatieContractAfspraken from './RelatieContractAfspraken.vue';
export default {
    name: 'RelatieContracten',
    components: {
        RelatieContractAfspraken
        
    },
   mixins: [serviceMixin],

    props: {
        relatie: {
            type: Object,
            default: () => null,
        },
        id: {
            type: Number,
            required: true
        }
    },
    data() {
        return  {
            mode: 'documenten',
            modes: ['documenten', 'afspraken'],
            installateur: 'MO2',
            filter: null,
            jaar: new Date().getFullYear(),
            contracten: {
              filters: [],
              documenten: []
            },
            upload_document: null,
            busy: false
        }
    },
    computed: {
        isInstallateurSelected() {
            return this.installateur !== null;
        },
        uploadApiPath() {
            var id = this.$props.id;
            return `/relatie/${id}/contracten`;
        }
    },
    watch: {},
    mounted() {
        this.getDocumenten();
    },
    methods: {
        getDocumenten() {
            this.get(this.uploadApiPath).then((response) => {
                this.contracten = response.data;
            });
        },
        upload() {
            
            var vm = this;
            vm.busy = true;
            
            var formdata = new FormData();
            formdata.append("file_content", this.upload_document);
            formdata.append("file_name", this.upload_document.name);
            formdata.append("tag_installateur", "MO2");

            this.postMultipart(this.uploadApiPath, formdata)
                .then(function (response) {
                    vm.contracten.push(response.data.document);
                })
                .catch(function (error) {
                    console.log(error);
                })
                .finally(() => { 
                    vm.busy = false 
                });
        },

    }
}
</script>